/*
 * De deelknop op een productpagina. Zie snippets/km-delen.liquid
 *
 * Op een telefoon of tablet die zelf een deelmenu heeft, opent de knop dat menu —
 * dan kan de bezoeker delen met de apps die hij zelf gebruikt. Kan het toestel dat
 * niet (de meeste computers), dan klapt er een rijtje open met WhatsApp, Facebook,
 * e-mail en "Link kopiëren".
 */
(function () {
  // Elke sectie van de pagina heeft zijn eigen laag; het rijtje van deze knop zit in de
  // sectie met de productinfo en verdween daardoor achter het witte vlak van
  // "Gerelateerde producten" eronder. Zolang het rijtje open staat, tilt deze klasse de
  // hele sectie een laagje op.
  function laagOp(blok, aan) {
    var sectie = blok.closest('.shopify-section');
    if (sectie) sectie.classList.toggle('km-delen-boven', aan);
  }

  function sluitAlles(behalve) {
    document.querySelectorAll('[data-km-delen]').forEach(function (blok) {
      if (blok === behalve) return;
      var paneel = blok.querySelector('[data-km-delen-paneel]');
      var knop = blok.querySelector('[data-km-delen-open]');
      if (paneel) paneel.hidden = true;
      if (knop) knop.setAttribute('aria-expanded', 'false');
      laagOp(blok, false);
    });
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-km-delen-open]');
    var kopieer = event.target.closest('[data-km-delen-kopieer]');

    if (open) {
      var blok = open.closest('[data-km-delen]');
      var adres = blok.dataset.kmDelenAdres;
      var titel = blok.dataset.kmDelenTitel;

      // Het deelmenu van het toestel zelf, maar alleen op een aanraakscherm. Op een
      // computer heeft Chrome dat menu ook, en daar opent het een systeemvenster dat
      // los van de website staat; het eigen rijtje is daar prettiger.
      var aanraakscherm = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      if (navigator.share && aanraakscherm) {
        event.preventDefault();
        navigator.share({ title: titel, text: titel, url: adres }).catch(function () {
          /* de bezoeker heeft het menu weggeklikt; niets aan de hand */
        });
        return;
      }

      var paneel = blok.querySelector('[data-km-delen-paneel]');
      var wasDicht = paneel.hidden;
      sluitAlles(blok);
      paneel.hidden = !wasDicht;
      open.setAttribute('aria-expanded', wasDicht ? 'true' : 'false');
      laagOp(blok, wasDicht);
      return;
    }

    if (kopieer) {
      var houder = kopieer.closest('[data-km-delen]');
      var link = houder.dataset.kmDelenAdres;
      var label = kopieer.querySelector('[data-km-delen-kopieer-label]');

      var klaar = function () {
        if (!label) return;
        var oud = label.textContent;
        label.textContent = 'Gekopieerd!';
        kopieer.classList.add('km-delen__optie--gelukt');
        window.setTimeout(function () {
          label.textContent = oud;
          kopieer.classList.remove('km-delen__optie--gelukt');
        }, 2000);
      };

      // Langs een tijdelijk invulvak: werkt ook als de browser het nette kopieren
      // weigert (dat mag hij, bijvoorbeeld als het tabblad niet de aandacht heeft).
      var oudeManier = function () {
        var vak = document.createElement('input');
        vak.value = link;
        document.body.appendChild(vak);
        vak.select();
        try {
          document.execCommand('copy');
        } catch (e) {
          /* niets: dan blijft het bij de melding */
        }
        document.body.removeChild(vak);
        klaar();
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(klaar).catch(oudeManier);
      } else {
        oudeManier();
      }
      return;
    }

    // Ergens anders geklikt: het rijtje weer dicht.
    if (!event.target.closest('[data-km-delen]')) sluitAlles(null);
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') sluitAlles(null);
  });
})();
